module.exports = __webpack_public_path__ + "static/img/icons2.fc7e77b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/icons2.png
// module id = 1323
// module chunks = 525